import {Avatar} from '@mui/material'
import {FileWithArrowUp} from '../../../../assets/icons/fileWithArrowUp'

import {Button, FlexBlock, SignalLevel} from '../../../customStyledElements'
import {Link} from 'react-router-dom'
import {getSubjectId} from '../../../../pages/biomarkers/[id]/IndicatorsAndSignals'
import {THead} from '../indicators-signals-table/IndicatorsSignalTable'
import {EmptyTable, getScaleTypeByIndex} from '../../../../pages/subjects/Subject'
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux";
import {Creator, CreatorTD} from '../indicators-signals-table/tableComponents'
import {Searchify} from '../../../myTable/MyTable'
import {ConnectButton} from "../../connectTo/interpretations/tableComponents";
import {patchRemove} from "../../../../redux/slice/data";
import React from "react";
import {RemoveBtn} from "../../../listMenu/listMenu";

const TITLE_LENGTH = 30

export const Empty = () => {
    return <EmptyTable name={'itnerpretation'}/>
}

export const NothingFound = () => {
    return (
        <tr>
            <td colSpan={1000} className={'nothing-found'}>
                Nothing Found ....
            </td>
        </tr>
    )
}

export const InterpretationsHead = () => {
    return (
        <THead>
            <tr>
                <td style={{width: '100px'}}>#</td>
                <td>Diseases</td>
                <CreatorTD></CreatorTD>
                <td>Recommendations</td>
                <td style={{width: '25%'}}>Signals</td>
            </tr>
        </THead>
    )
}

export const FileWrapper = (props: any) => {
    const {to, abs, top} = props;
    const styles = top ? {marginTop: top} : {}
    let data = abs ? {'data-file-abs': true} : {}

    return to ? <Link to={to} className={'data-file-down'} {...data}>
        <FileWithArrowUp style={{...styles}}/>
    </Link> : <a className={'data-file-down'}>
        <FileWithArrowUp/>
    </a>
}

export const TDIdTableLInk = ({item, to}: { to: string, item: any }) => {
    return <td><Link to={to} data-desc2>#{item._id}</Link></td>
}

export const InterpretationsBody = (props: any) => {
    const {item, search, ind, onConnect, connectIds, language = 'en'} = props;
    const {recommendations, indicators} = useAppSelector((state) => state.data)
    const dispatch = useAppDispatch();

    function getSignals(item: any) {
        return [...item.signalSets.map((it: any) => it.signals)].flat()
    }

    let signals = getSignals(item) || []
    let linkTo = '/' + getSubjectId() + '/diseases/' + item._id;

    return (
        <tbody>
        <tr>
            <TDIdTableLInk to={linkTo} item={item}></TDIdTableLInk>
            <td>
                <div data-td-center>

                    {onConnect && <ConnectButton
                        item={item}
                        onConnect={onConnect}
                        connectIds={connectIds}
                    />}
                    {/*<FileWrapper to={linkTo} top={-2} abs={true}></FileWrapper>*/}

                    {/*<Link to={linkTo} data-ellipse data-title>*/}
                    {/*    {item.name}*/}
                    {/*</Link>*/}
                    <FileWrapper to={linkTo} top={5} abs={true}></FileWrapper>
                    <Link to={linkTo} data-ellipse data-title>
                        <Searchify value={item.name} search={search} length={35}></Searchify>
                    </Link>
                </div>
            </td>
            <td>
                <Creator item={item}></Creator>
            </td>
            <td>
                <Link to={linkTo}>

                    <FlexBlock style={{marginLeft: '-15px', overflowX: 'auto'}}>

                        <p data-ellipse>
                            {(item.recommendationIds || []).map((it: any, ind: number) => {
                                return (<span style={{padding: '0 5px'}}>
                                    {(() => {
                                        const recommendation = recommendations[it] || {};
                                        const name = recommendation.name;
                                        return typeof name === 'object' 
                                            ? name?.en || name?.[Object.keys(name || {})[0]] || ('#' + it)
                                            : name || ('#' + it);
                                    })()}
                                </span>)
                            })}
                        </p>

                    </FlexBlock>
                </Link>

            </td>
            <td data-rel>
                <FlexBlock style={{overflowX: 'auto'}}>
                    <Link to={linkTo}>
                        {signals.map((it: any, ind: number) => {
                            if (!it) {
                                return null
                            }
                            let indicator = (indicators[it?.indicatorId] || {});
                            let {color, type} = getScaleTypeByIndex(indicator, it.signalIndex)
                            return (<div key={ind} style={{display: 'inline-block'}}>
                                <Button style={{display: 'inline-flex'}}>
                                    <SignalLevel color={color}>{it.valueFrom} - {it.valueTo}</SignalLevel>
                                    <span style={{padding: '2px 5px'}}>
                                        {typeof indicator.name === 'object' 
                                            ? indicator.name?.en || indicator.name?.[Object.keys(indicator.name || {})[0]] || ('#' + it.indicatorId)
                                            : indicator.name || ('#' + it.indicatorId)}
                                    </span>
                                </Button>
                            </div>)
                        })}
                    </Link>

                </FlexBlock>
                <RemoveBtn
                    name={typeof item.name === 'object' 
                        ? item.name?.en || item.name?.[Object.keys(item.name || {})[0]] || ''
                        : item.name || ''}
                    data-remove-btn
                    absTop={10}
                    top={0} onClick={() => {
                    dispatch(patchRemove({_id: item._id, type: 'interpretations'}))
                }}></RemoveBtn>
            </td>

        </tr>
        </tbody>
    )
}
